import { Wrench, Loader2, AlertCircle } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const ServiceCoverThumb = ({ service, testId }) => {
  const images = service.images || [];
  const primary = images.find((img) => img.is_primary) || images[0];
  const pending = service.image_generation_status === "pending";
  const failed = service.image_generation_status === "failed";

  if (!primary && pending) {
    return (
      <div data-testid={testId} className="relative h-16 w-16 shrink-0 overflow-hidden rounded-xl border border-dashed border-blue-300 bg-blue-50 dark:border-blue-500/30 dark:bg-blue-500/10">
        <div className="absolute inset-0 animate-pulse bg-gradient-to-br from-blue-100 to-blue-50 dark:from-blue-500/10 dark:to-transparent" />
        <div className="relative flex h-full w-full flex-col items-center justify-center gap-1" data-testid={`${testId}-generating`}>
          <Loader2 size={16} className="animate-spin text-blue-500 dark:text-blue-400" />
          <span className="text-center text-[7px] font-bold uppercase leading-tight tracking-wide text-blue-500 dark:text-blue-400">Generating…</span>
        </div>
      </div>
    );
  }

  if (!primary && failed) {
    return (
      <div data-testid={`${testId}-failed`} className="flex h-16 w-16 shrink-0 flex-col items-center justify-center gap-1 rounded-xl border border-dashed border-red-300 bg-red-50 text-red-500 dark:border-red-500/30 dark:bg-red-500/10 dark:text-red-400">
        <AlertCircle size={16} />
        <span className="text-[7px] font-bold uppercase leading-tight tracking-wide">Failed</span>
      </div>
    );
  }

  if (!primary) {
    return (
      <div data-testid={testId} className="flex h-16 w-16 shrink-0 items-center justify-center rounded-xl border border-dashed border-slate-200 text-slate-300 dark:border-white/15 dark:text-slate-600">
        <Wrench size={20} />
      </div>
    );
  }

  return (
    <div data-testid={testId} className="h-16 w-16 shrink-0 overflow-hidden rounded-xl border border-slate-200 dark:border-white/15">
      <img src={`${BACKEND_URL}${primary.url}`} alt={primary.alt_text || service.name} className="h-full w-full object-cover" />
    </div>
  );
};
